<script>
import mixinComponent from '../../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../../Mixins/global'
import { markRaw } from 'vue'
import AddUserButtonAndModal from '../../Entity/AddUserButtonAndModal.vue'
import DirectorModal from '../../Entity/DirectorModal.vue'
import EntityModal from '../../Entity/EntityModal.vue'
import { testPattern } from '../../../../Utils/regexUtils'
import { DateTime } from 'luxon'
import OptionItem from './Field/OptionItem.vue'
import { groupBy, orderBy, isObject, get } from 'lodash'
import { FIELD_TYPE_CHOICE, FIELD_TYPE_ENUM } from '../../../Constants/FieldType'

export default {
  components: { OptionItem, EntityModal, DirectorModal, AddUserButtonAndModal },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    modelValue: { type: [String, Number, Object, Boolean], required: false },
    name: { type: String, required: true },
    domain: { type: String, required: false },
    formRef: { type: String, required: true },
    labelTop: { type: Boolean, default: false },
    labelLeft: { type: Boolean, default: false },
    labelRight: { type: Boolean, default: false },
    labelLeftEqual: { type: [Boolean, String], default: false },
    dynamicLabel: { type: Boolean, default: false },
    specificLabel: { type: String, default: null },
    label: { type: String, default: null },
    placeholder: { type: String, required: false, default: null },
    placeholderConfig: { type: Boolean, default: true },
    placeholderLabel: { type: Boolean, default: false },
    endpoint: { type: String, required: false },
    objectId: { type: Number, default: null },
    clientId: { type: Number, default: null },
    financeId: { type: Number, default: null },
    decisionId: { type: Number, default: null },
    simulationId: { type: Number, default: null },
    contractId: { type: Number, default: null },
    entityId: { type: Number, default: null },
    directorId: { type: Number, default: null },
    addUser: { type: Boolean, default: false },
    addUserPlaceholder: { type: Boolean, default: false },
    addDirector: { type: Boolean, default: false },
    addEntity: { type: Boolean, default: false },
    editEntity: { type: Boolean, default: false },
    userEntity: { type: Boolean, default: false },
    update: { type: Boolean, default: false },
    refreshField: { type: Boolean, default: false },
    refresh: { type: [Boolean, String], default: false },
    forceRefresh: { type: Boolean, default: false },
    endpointRefresh: { type: String, default: null },
    toPost: { type: Boolean, default: false },
    reload: { type: Boolean, default: false },
    hidden: { type: Boolean, default: false },
    objName: { type: String, default: null },
    multiple: { type: Boolean, default: false },
    editor: { type: Boolean, default: false },
    collectionName: { type: String, default: null },
    collectionIndex: { type: Number, default: null },
    collectionSpecific: { type: Boolean, default: false },
    collectionPrototype: { type: Boolean, default: false },
    selectChange: { type: [String, Object], default: null },
    selectChangeByName: { type: [String, Object], default: null },
    notRemove: { type: Boolean, default: false },
    notRequired: { type: Boolean, default: false },
    multipleChoice: { type: Boolean, default: false },
    dynamicForm: { type: Boolean, default: false },
    selectMultiple: { type: Boolean, default: false },
    minDatetime: { type: String, default: null },
    maxDatetime: { type: String, default: null },
    platformParamId: { type: Number, default: null },
    platformId: { type: Number, default: null },
    defaultValue: { type: String, default: null },
    typeValue: { type: String, default: 'int' },
    labelProperty: { type: String, default: null },
    valueProperty: { type: String, default: null },
    groupProperty: { type: String, default: null },
    formData: { type: [Array, Object], required: true },
    disabled: { type: Boolean, default: false },
    ignoreUserReadonly: { type: Boolean, default: false },
    userSelectAllowGrow: { type: Boolean, default: false },
    allowNull: { type: Boolean, default: false },
    disabledOptions: {
      type: Array, // List of disabled options values
      required: false,
      default: [],
    },
  },
  emits: [
    'get-select-change',
    'get-date-change',
    'get-input-change',
    'update:modelValue',
    'checked',
    'editor-change',
    'entity-submitted',
    'collection-value',
    'get-autocomplete-result',
    'options-changed',
  ],
  data() {
    return {
      field: null,
      select: null,
      quill: null,
      userId: null,
      userEntityId: null,
      dataEntry: null,
      selected: false,
      results: [],
    }
  },
  methods: {
    toPickerDate(value) {
      if (!value) {
        return null
      }
      const date = DateTime.fromISO(value)
      return date.isValid ? date.toJSDate() : null
    },
    onClickCalendar() {
      this.datepickerElement.datepicker('show')
    },
    eventSelect() {
      if (this.financeId) {
        Object.assign(this.getFormCreator().datas, { financeId: this.financeId })
      }

      if (this.isSelect) {
        let choices = this.field.options.choices
        let text = null
        if (choices) {
          this.getSelectChoice(choices)
        }

        //on déconstruit puis reconstruit, ça permet d'éviter la boucle
        let options = this.select2Options
        this.select = $(this.$el).find('select').select2(options)
        this.select.off('change')
        this.select = $(this.$el).find('select').select2(options)

        // Set the initial value for select2, especially important for multiple selections
        let initialValue = this.getFormValue()
        if (initialValue !== null && initialValue !== undefined) {
          if (Array.isArray(initialValue)) {
            // Extract IDs from array of objects, or use values directly if they're primitives
            initialValue = initialValue.map((val) =>
              val && typeof val === 'object' && val.id ? String(val.id) : String(val),
            )
          } else {
            initialValue = String(initialValue)
          }
          $(this.$el).find('select').val(initialValue).trigger('change.select2')
        }

        if (this.isDisabled) {
          $(this.$el).find('select').select2('enable', false)
        }

        if (this.field.type === 'entity_identity') {
          this.select.on('select2:open', () => {
            let searchField = $('.select2-search__field')

            searchField.on('input', (e) => {
              let searchValue = e.target.value
              let regex = /^[A-Za-z]{2}\d/
              let ebeSiren = regex.test(searchValue)
              if (ebeSiren) {
                this.dataEntry = searchValue
              }
            })
          })
        }

        this.select.on('change', (event) => {
          text = $('#' + this.inputId)
            .find(':selected')
            .text()

          if (this.collectionName) {
            this.form[this.collectionName][this.collectionIndex][this.name] = this.selectMultiple
              ? Array.from($('#' + this.inputId).find(':selected'))
                  .map((option) => {
                    const value = option.value
                    if (this.typeValue === 'int' && !this.dynamicForm && value !== '') {
                      return parseInt(value)
                    }
                    if (this.typeValue === 'float') {
                      return parseFloat(value)
                    }
                    return value
                  })
                  .filter((val) => val !== '')
              : $('#' + this.inputId)
                  .find(':selected')
                  .val()
            if (this.userEntity) {
              this.getFormCreator().def[this.collectionName][this.collectionIndex][this.name].options.choices.forEach(
                (option) => {
                  if (option.id == this.form[this.collectionName][this.collectionIndex][this.name]) {
                    this.userId = option.user.id
                    this.userEntityId = option.id
                  }
                },
              )
            }
          } else {
            let selectElement = event.target

            const values = Array.from(selectElement.selectedOptions)
              .filter(({ value }) => value !== '')
              .map((option) => {
                const value = option.value
                if (value === 'null') {
                  return null
                }
                if (this.typeValue === 'int' && !this.dynamicForm) {
                  return parseInt(value)
                }
                if (this.typeValue === 'float') {
                  return parseFloat(value)
                }
                return value
              })

            if (this.selectMultiple || this.multipleChoice) {
              this.form[this.name] = values
            } else {
              this.form[this.name] = values[0] ?? null
            }

            if (this.userEntity) {
              this.getFormCreator().def[this.name].options.choices.forEach((option) => {
                if (option.id == this.form[this.name]) {
                  this.userId = option.user.id
                  this.userEntityId = option.id
                }
              })
            }
          }

          //récupération id user entity depuis l'objet def au click
          if (this.field.options.refresh) {
            this.getFormCreator().methods('refresh')
          } else if (this.refresh) {
            if (this.endpointRefresh !== null) {
              this.getFormCreator()._props.specificEndpoint = this.endpointRefresh
            }
            this.getFormCreator().methods('patch', this.reload)
          } else if (this.refreshField) {
            for (const key in this.getFormCreator().datas) {
              if (this.getFormCreator().datas[key] !== this.form[this.name]) {
                delete this.getFormCreator().datas[key]
              }
            }
            this.getFormCreator().methods('patch', this.reload)
          } else if (this.toPost) {
            if (this.decisionId !== null) {
              this.getFormCreator().datas['decisionId'] = this.decisionId
            }

            this.getFormCreator().datas['send'] = false
            this.getFormCreator().methods('post')
          }

          if (this.update) {
            this.getFormCreator().methods('update')
          }

          if (choices) {
            this.getSelectChoice(choices)
          }

          if (this.collectionName) {
            this.$emit(
              'get-select-change',
              this.form[this.collectionName][this.collectionIndex][this.name],
              choices,
              text,
              this.name,
            )
            this.recalculateErrors(this.form[this.collectionName][this.collectionIndex][this.name])
          } else {
            this.$emit('update:modelValue', this.selectedOption)
            this.$emit('get-select-change', this.form[this.name], choices, text, this.name)
            this.recalculateErrors(this.form[this.name])
          }
        })
      }
    },

    eventCheckbox() {
      if (this.field.type === 'checkbox') {
        let formValue = this.getFormValue()
        this.$emit('checked', formValue)

        const checkbox = $('#' + this.inputId)
        checkbox.off('change') // Avoid multiple listeners
        checkbox.change((e) => {
          const isChecked = $(e.target).is(':checked')
          this.$emit('checked', isChecked)
          if (!this.forceRefresh) {
            this.recalculateErrors(this.getFormValue())
          }
          if (this.refresh) {
            if (this.financeId) {
              Object.assign(this.getFormCreator().datas, { financeId: this.financeId })
            }
            if (this.endpointRefresh !== null) {
              this.getFormCreator()._props.specificEndpoint = this.endpointRefresh
            }
            this.getFormCreator().methods(this.forceRefresh ? 'force' : 'patch', this.reload)
          }
        })
      }
    },

    refreshDatepicker() {
      if (this.field?.type === 'date') {
        this.datepickerElement.datepicker('destroy')
        this.datepickerElement.datepicker(this.datePickerOptions)
      }
    },

    eventDate() {
      if (this.field?.type === 'date') {
        let id = this.datepickerElement

        this.refreshDatepicker()

        id.on('changeDate', ({ date: dateValue }) => {
          const date = DateTime.fromJSDate(dateValue)

          if (this.collectionName) {
            this.form[this.collectionName][this.collectionIndex][this.name] = date.toISO()
          } else {
            this.form[this.name] = date.toISO()
          }
          if (this.refresh) {
            if (this.financeId) {
              Object.assign(this.getFormCreator().datas, { financeId: this.financeId })
            }
            if (this.endpointRefresh !== null) {
              this.getFormCreator()._props.specificEndpoint = this.endpointRefresh
            }
            this.getFormCreator().methods('patch')
          }

          id.datepicker('hide')
          this.$emit('get-date-change', date)
          this.recalculateErrors(
            this.collectionName
              ? this.form[this.collectionName][this.collectionIndex][this.name]
              : this.form[this.name],
          )
        })
      }
    },

    quillEditor() {
      if (this.editor) {
        let container = this.$refs[this.inputId]
        let formValue = this.getFormValue()

        if (container.querySelector('.ql-editor')) {
          this.quill.clipboard.dangerouslyPasteHTML(formValue)
        } else {
          this.quill = markRaw(
            new Quill(container, {
              theme: 'snow',
              placeholder: this.$t('main.formText'),
            }),
          )

          this.quill.clipboard.dangerouslyPasteHTML(formValue)
        }

        if (this.isDisabled) {
          this.quill.enable(false)
        }

        this.quill.on('text-change', (delta, source) => {
          this.compVal = this.quill.root.innerHTML
          this.$emit('editor-change', this.quill.root.innerHTML)
          this.recalculateErrors(this.quill.root.innerHTML)
        })
      }
    },

    recalculateErrors(fieldValue = null) {
      const value = fieldValue !== null ? fieldValue : this.getFormValue()
      const isEmpty = value === null || value === undefined || value === ''
      let hasError = false

      if (this.field.options.required && isEmpty && !this.allowNull) {
        hasError = true
      } else if (!isEmpty && this.field.options.constraints?.pattern) {
        const patternResult = testPattern(this.field.options.constraints.pattern, String(value))
        hasError = !patternResult
      }

      this.getFormCreator().errors[this.name] = hasError
    },

    inputChange(e) {
      let formValue = this.getFormValue()
      if (this.field?.type === 'date') {
        const date = DateTime.fromFormat(formValue, 'dd/mm/yyyy')
        this.$emit('get-date-change', date.isValid ? date : null)
      }

      this.$emit('get-input-change', formValue, e, this.name)
      this.$emit('update:modelValue', formValue)
      if (this.field.options.refresh && this.field.options.regex) {
        if (formValue.match(new RegExp(this.field.options.regex, 'g'))) {
          if (this.financeId) {
            Object.assign(this.getFormCreator().datas, { financeId: this.financeId })
          }
          this.getFormCreator().methods('refresh', this.reload)
        }
      }

      if (!this.forceRefresh) {
        this.recalculateErrors(formValue)
      }
    },

    eventFile(file) {
      if (file && file.length) {
        if (conf.fileMaxSize > 0 && file[0].size > conf.fileMaxSize) {
          let fileMaxSize = conf.fileMaxSize
          if (fileMaxSize < 1000) {
            fileMaxSize = '1 Ko'
          } else {
            fileMaxSize = fileMaxSize / 1000
            if (fileMaxSize < 1000) {
              fileMaxSize = fileMaxSize + ' Ko'
            } else {
              fileMaxSize = fileMaxSize / 1000 + ' Mo'
            }
          }
          alert(this.$t('document.errorFileMaxSize', { fileMaxSize: fileMaxSize }))
          return
        }
        let fileExtensions = conf.fileExtensionAuthorized.toLowerCase().split(',')
        let fileExtension = ''
        let index = file[0].name.lastIndexOf('.')
        if (index > 0) {
          fileExtension = file[0].name.substring(index + 1).toLowerCase()
        }
        if (fileExtensions.indexOf(fileExtension) < 0) {
          fileExtension = ''
          for (let i = 0; i < fileExtensions.length; i++) {
            if (i > 0) {
              fileExtension += ', '
            }
            fileExtension += "'." + fileExtensions[i] + "'"
          }
          alert(this.$t('document.errorFileExtension', { fileExtension: fileExtension }))
          return
        }

        let reader = new FileReader()
        this.$refs.fileInput.innerHTML = file[0].name
        this.selected = true

        //TODO: construire l'objet document
        this.form[this.name] = file
      }
    },

    iformat(data) {
      var originalOption = data.element
      var text = $('<div>').text(data.text).html()
      return $(
        '<span>' +
          text +
          ' <i class="' +
          $(originalOption).data('icon') +
          '" style="color:' +
          $(originalOption).data('color') +
          '"></i></span>',
      )
    },

    addOption(option, value) {
      $('#' + this.inputId)
        .append(option)
        .trigger('change.select2')
      this.form[this.name] = value
    },

    addEntityOption(entity) {
      const label = this.getEntityOptionLabel(entity)
      const option = new Option(label, entity[this.valueProperty], true, true)
      this.addOption(option, entity[this.valueProperty])
      this.$emit('entity-submitted', entity.siren, undefined, label, this.name, entity)
    },

    addSelect(data, e = null) {
      if (e.data?.user && Array.isArray(this.field.options.choices)) {
        this.field.options.choices.push(e.data.user)
      }

      const newValue = this.selectMultiple || this.multipleChoice ? [e.value] : e.value
      if (this.collectionName) {
        this.form[this.collectionName][this.collectionIndex][this.name] = newValue
      } else {
        this.form[this.name] = newValue
      }

      if (this.refresh) {
        if (this.financeId) {
          Object.assign(this.getFormCreator().datas, { financeId: this.financeId })
        }
        if (this.endpointRefresh !== null) {
          this.getFormCreator()._props.specificEndpoint = this.endpointRefresh
        }
        this.getFormCreator().methods('patch', this.reload)
      }

      this.$emit('options-changed')
    },
    updateOption(option) {
      if (!Array.isArray(this.field.options.choices)) {
        return
      }

      for (let index = 0; index < this.field.options.choices.length; index++) {
        if (this.field.options.choices[index].id === option.id) {
          this.field.options.choices[index] = option
        }
      }

      this.$emit('options-changed')
    },
    getSelectChoice(choices) {
      /**si on a une modification du select alors récupères le form puis on transfert la liste correspondante
       *(props: selectChangeByName = les options à récuperer, selectChange = la config à modifier)
       */
      if (this.selectChangeByName) {
        let formConfig, formObject
        /** cas si on a string ou array, mais faudra faire que en array donc retirer le reste */
        if (typeof this.selectChange == 'string') {
          if (this.selectChange.includes('.')) {
            let nameField = this.selectChange.split('.')
            formConfig = this.getFormCreator().def[nameField[0]][nameField[1]]
            //formObject = this.getFormCreator().object[nameField[0]][nameField[1]];
          } else {
            formConfig = this.getFormCreator().def[this.selectChange]
            //formObject = this.getFormCreator().object[this.selectChange];
          }
          if (this.collectionName) {
            choices.map((choice) => {
              if (choice.id == this.form[this.collectionName][this.collectionIndex][this.name]) {
                formConfig.options.choices = choice[this.selectChangeByName]
                // formObject = null;
                // if(choice[this.selectChangeByName].length == 1){
                //   formObject = choice[this.selectChangeByName][0].id;
                // }
              }
            })
          } else {
            choices.map((choice) => {
              if (choice.id == this.form[this.name]) {
                formConfig.options.choices = choice[this.selectChangeByName]
                // formObject = null;
                // if(choice[this.selectChangeByName].length == 1){
                //   formObject = choice[this.selectChangeByName][0].id;
                // }
              }
            })
          }
        } else {
          this.selectChange.map((select, index) => {
            if (select.includes('.')) {
              let nameField = select.split('.')
              formConfig = this.getFormCreator().def[nameField[0]][nameField[1]]
              //formObject = this.getFormCreator().object[nameField[0]][nameField[1]];
            } else {
              formConfig = this.getFormCreator().def[select]
              //formObject = this.getFormCreator().object[this.selectChange];
            }

            if (this.collectionName) {
              choices.map((choice) => {
                if (choice.id == this.form[this.collectionName][this.collectionIndex][this.name]) {
                  formConfig.options.choices = choice[this.selectChangeByName[index]]
                  // formObject = null;
                  // if(choice[this.selectChangeByName].length == 1){
                  //   formObject = choice[this.selectChangeByName][0].id;
                  // }
                }
              })
            } else {
              choices.map((choice) => {
                if (choice.id == this.form[this.name]) {
                  formConfig.options.choices = choice[this.selectChangeByName[index]]
                  // formObject = null;
                  // if(choice[this.selectChangeByName].length == 1){
                  //   formObject = choice[this.selectChangeByName][0].id;
                  // }
                }
              })
            }
          })
        }
      } else {
        if (this.dynamicForm && Array.isArray(choices)) {
          choices.map((choice) => {
            if (choice.id == this.form[this.name]) {
              for (const [subselectkey, subselect] of Object.entries(choice)) {
                if (subselectkey != 'id' && subselectkey != 'name') {
                  // on reconstruit le nom en conservant la racine du chemin
                  let nameField = this.name.split('.')
                  nameField.pop()
                  nameField.push(subselectkey)
                  let subselectkey2 = nameField.join('.')
                  //formConfig = this.getFormCreator().def[nameField[0]][subselectkey];
                  formConfig = this.arrayGet(this.getFormCreator().def, subselectkey2)
                  if (formConfig) {
                    formConfig.options.choices = choice[subselectkey]
                  }
                }
              }
            }
          })
        }
      }
    },

    getFormCreator() {
      return Array.isArray(this.formData) ? this.formData[this.formRef] : this.formData //if array get the ref of the formCreator
    },

    getFormObjectValue() {
      let formCreator = this.getFormCreator()
      let objectValue
      const OBJECT_PROPERTY_DELIMITER = '.'
      const object = this.collectionName
        ? formCreator.object[this.collectionName][this.collectionIndex]
        : formCreator.object
          ? formCreator.object
          : null
      if (!object) {
        if (
          this.collectionSpecific &&
          formCreator.object[this.collectionName] &&
          formCreator.object[this.collectionName][this.collectionIndex]
        ) {
          return formCreator.object[this.collectionName][this.collectionIndex].value
        }

        return object
      }

      if (this.name.includes(OBJECT_PROPERTY_DELIMITER)) {
        if (object[this.name.split('.')[0]] == null) {
          return null
        }
        objectValue = this.arrayGet(object, this.name, this.objName)
      } else {
        objectValue = this.arrayGet(object, this.name)
      }

      if (objectValue && typeof objectValue == 'object') {
        if (objectValue.id) {
          return objectValue.id
        } else if (objectValue.value) {
          return objectValue.value
        } else if (objectValue.internalName) {
          return objectValue.internalName
        } else if (Array.isArray(objectValue)) {
          // Handle arrays - could be array of objects with .id or array of primitive values
          let select2multiple = []
          for (const [index, data] of Object.entries(objectValue)) {
            if (data && typeof data === 'object' && data.id) {
              select2multiple.push(data.id)
            } else if (data) {
              // Handle array of primitive values (IDs, strings, etc)
              select2multiple.push(data)
            }
          }
          return select2multiple
        }
      } else {
        if (
          this.field.options['ajax'] &&
          this.field.options['ajax'] != 'pappers' &&
          this.field.options.ajax.initValues
        ) {
          return this.field.options.ajax.initValues[0].id
        } else {
          return objectValue
        }
      }
    },

    getFormValue() {
      if (!this.form) {
        return null
      }

      if (this.collectionSpecific) {
        if (this.form[this.collectionName]?.[this.collectionIndex] === undefined && this.field.options.checked) {
          this.form[this.collectionName][this.collectionIndex] = this.field.options.checked
        }
        return this.form[this.collectionName]?.[this.collectionIndex] ?? null
      }

      if (this.collectionName) {
        if (
          this.form[this.collectionName]?.[this.collectionIndex]?.[this.name] === undefined &&
          this.field.options.checked
        ) {
          this.form[this.collectionName][this.collectionIndex][this.name] = this.field.options.checked
        }
        return this.form[this.collectionName]?.[this.collectionIndex]?.[this.name] ?? null
      }

      if (this.form[this.name] === undefined && this.field.options.checked) {
        this.form[this.name] = true
      }
      return this.form[this.name] ?? null
    },
    getOptionLabel(option) {
      if (this.labelProperty && option[this.labelProperty]) {
        return option[this.labelProperty]
      }

      const labelTranslated = option.label && this.$te(option.label)
      if (labelTranslated) {
        return this.$t(option.label)
      }
      if (option.name) {
        return option.name
      }
      if (option.user) {
        return option.user.name
      }
      return option.id
    },
    getOptionValue(option) {
      if (option.id || option.id === 0 || (option.id === null && this.allowNull)) {
        return option.id
      }
      if (option.internalName) {
        return option.internalName
      }
      return option.name
    },
    getEntityOptionLabel(entity) {
      return [entity.name, entity.siren, entity.address?.city, entity.address?.postalCode]
        .filter((part) => !!part)
        .join(' - ')
    },
    arrayGet: function (list, key, obj = null) {
      let listBefore = list
      if (key.includes('.')) {
        let keys = key.split('.')
        for (let j in keys) {
          let next = keys[j]
          list = list[next]

          //si la liste ne contient pas la clé à revoir lorsqu'on aura l'objet = def
          if (list == undefined && obj) {
            list = listBefore[obj][next]
          }
        }
        return list
      } else {
        return list[key]
      }
    },
    isDisabledOption(value) {
      return this.disabledOptions.includes(value)
    },
  },

  computed: {
    nameAndFormRef() {
      const name = [this.name, this.formRef].filter(Boolean).join('-')

      if (!name) {
        return null
      }

      return `-${name}`
    },
    areOtherUsersEditableInForm() {
      return (
        Object.values(this.getFormCreator().def?.signers)?.filter(
          (field) => !field.options.userNotEditable && field.options.display,
        ).length > 0
      )
    },
    showAddUserButtonModal() {
      return (
        (this.addUserPlaceholder && this.areOtherUsersEditableInForm) ||
        (!this.user?.isReadOnly && this.addUser && !this.isDisabled && !this.field?.options.userNotEditable)
      )
    },
    addUserButtonAndModalClasses() {
      return {
        'ml-2': true,
        invisible: this.addUserPlaceholder,
      }
    },
    isLabelDivCol6() {
      const noUserGrow =
        !this.userSelectAllowGrow ||
        ((!this.addUser || this.isDisabled) && (!this.addUserPlaceholder || !this.areOtherUsersEditableInForm))

      return this.labelLeftEqual && noUserGrow
    },
    isLabelDivCol4() {
      const canAddUserOrDirector = (this.addUser || this.addDirector) && !this.isDisabled
      const canUsePlaceholder = this.addUserPlaceholder && this.areOtherUsersEditableInForm

      return this.userSelectAllowGrow && this.labelLeftEqual && (canAddUserOrDirector || canUsePlaceholder)
    },
    isSimpleInputCol6() {
      const noUserGrow = !this.addUser || this.isDisabled || !this.userSelectAllowGrow

      const noPlaceholderGrow = !this.addUserPlaceholder || !this.areOtherUsersEditableInForm

      return this.labelLeftEqual && noUserGrow && noPlaceholderGrow
    },

    isSimpleInputCol8() {
      const canAddUser = this.addUser && !this.isDisabled
      const canAddPlaceholder = this.addUserPlaceholder && this.areOtherUsersEditableInForm

      return this.userSelectAllowGrow && this.labelLeftEqual && (canAddUser || canAddPlaceholder)
    },
    help() {
      if (this.field?.help) {
        return this.$t(this.field.help)
      }

      if (this.field?.options?.help) {
        return this.$t(this.field.options.help)
      }

      return null
    },
    helpVisible() {
      return this.help && this.field?.options?.help_visible
    },
    compVal: {
      get() {
        if (this.field.type === 'date') {
          return this.valueFormated
        }

        return this.getFormValue()
      },
      set(val) {
        if (this.collectionName) {
          if (this.collectionSpecific) {
            this.form[this.collectionName][this.collectionIndex] =
              this.getFormCreator().def[this.collectionName][this.collectionIndex].value
          } else {
            this.form[this.collectionName][this.collectionIndex][this.name] = val
            this.$emit('collection-value', { index: this.collectionIndex, name: this.name, value: val })
          }
        } else {
          this.form[this.name] = val
        }
      },
    },
    isDisabled() {
      return this.field.options.disabled || this.disabled
    },
    invalidName() {
      return this.name.replace(/\./g, '-')
    },
    divClasses() {
      return {
        'form-group': true,
        'my-2': true,
        row: this.labelLeft || this.labelLeftEqual,
        'align-items-baseline': this.labelLeft || this.labelLeftEqual,
        'd-none': !this.field.options.display,
        'w-100': this.editor,
        'd-flex': this.labelRight,
      }
    },
    labelDivClasses() {
      return {
        'col-xl-4': this.labelLeft,
        'col-md-12': this.labelLeft || this.labelRight,
        'col-md-6': this.isLabelDivCol6,
        'col-md-4': this.isLabelDivCol4,
        'w-auto': this.labelRight,
        'order-1': this.labelRight,
        'd-flex': true,
        'justify-content-between': true,
      }
    },
    labelClasses() {
      return {
        'fs-16': true,
        'form-label-font': true,
        'd-none': !this.field.options.display,
        'd-flex': this.labelLeft || this.labelLeftEqual,
        required: this.field.options.required && !this.isDisabled,
      }
    },
    editorClasses() {
      return {
        'col-xl-8': this.labelLeft,
        'col-md-12': this.labelLeft,
        'col-md-6': this.labelLeftEqual,
      }
    },
    simpleInputClasses() {
      return {
        'col-xl-8': this.labelLeft,
        'col-md-12': this.labelLeft,
        'col-md-6': this.isSimpleInputCol6,
        'col-md-8': this.isSimpleInputCol8,
        'input-group': this.field.type === 'date' || this.field.options.decoration !== undefined,
        'input-button': this.$slots.button,
      }
    },
    selectClasses() {
      return {
        'd-flex': this.addUserPlaceholder || this.addUser || this.$slots.add || this.addEntity || this.addDirector,
        'flex-nowrap': this.addUserPlaceholder || this.addUser || this.$slots.add || this.addEntity || this.addDirector,
        'input-group': this.field?.options?.decoration && !this.addEntity,
        'w-100': this.field?.options?.decoration && this.addEntity,
        'column-gap-2':
          this.addUserPlaceholder || this.addUser || this.$slots.add || this.addEntity || this.addDirector,
      }
    },
    selectFieldClasses() {
      return {
        'form-control': true,
        'is-invalid': this.getFormCreator()?.showErrors && !!this.getFormCreator()?.errors?.[this.name],
      }
    },
    addonClasses() {
      return {
        'basic-addon-right': this.addUser || this.$slots.add || this.addEntity || this.addDirector,
        'basic-addon-less-right': this.editEntity && !!this.modelValue,
      }
    },
    inputFieldClasses() {
      return {
        'checkbox-position': this.field.type === 'checkbox',
        'form-control': this.field.type !== 'checkbox',
        'is-invalid': this.getFormCreator()?.showErrors && !!this.getFormCreator()?.errors?.[this.name],
      }
    },
    textareaClasses() {
      return {
        'form-control': true,
        'field-sizing-content': true,
        'is-invalid': this.getFormCreator()?.showErrors && !!this.getFormCreator()?.errors?.[this.name],
      }
    },
    dateInputClasses() {
      return {
        'form-control': true,
        'is-invalid': this.getFormCreator()?.showErrors && !!this.getFormCreator()?.errors?.[this.name],
      }
    },
    fileButtonClasses() {
      const isSelected = this.selected
      return {
        'form-control': true,
        btn: true,
        'btn-success': isSelected,
        'btn-warning': !isSelected,
        'is-invalid': this.getFormCreator()?.showErrors && !!this.getFormCreator()?.errors?.[this.name],
      }
    },
    isSimpleInput() {
      return !['date', 'file', 'textarea', 'hidden'].includes(this.field?.type) && !this.hidden && !this.isSelect
    },
    hasLabel() {
      return (this.labelTop || this.labelLeft || this.labelLeftEqual || this.labelRight) && this.field.type !== 'hidden'
    },
    hasDecoration() {
      return (
        !['date', 'hidden'].includes(this.field?.type) &&
        !this.hidden &&
        !this.isSelect &&
        this.field?.options?.decoration
      )
    },
    setLabel() {
      if (this.label && this.$te(this.label)) {
        return this.$t(this.label)
      }

      return this.dynamicLabel
        ? this.getFieldLabel(this.name, this.domain, this.field.label)
        : this.getFieldLabel(this.name, this.domain, null, this.specificLabel)
    },
    clientFindId() {
      if (this.clientId) {
        return this.clientId
      }
      const client = this.getFormCreator().object.client
      if (client) {
        return client.id
      }

      return null
    },
    contractFindId() {
      if (this.financeId) {
        return null
      }

      return this.contractId
        ? this.contractId
        : this.simulationId || this.entityFindId
          ? null
          : this.getFormCreator().object.id
    },
    simulationFindId() {
      if (this.financeId) {
        return null
      }

      return this.simulationId
        ? this.simulationId
        : this.contractId || this.entityFindId
          ? null
          : this.getFormCreator().object.id
    },
    entityFindId() {
      if (this.entityId || this.field.options.entityId) {
        return this.entityId || this.field.options.entityId
      }

      return this.clientId ? null : (platform = this.getFormCreator().object.platform ? platform.id : null)
    },
    resolvedPlaceholder() {
      if (this.placeholder && this.$te(this.placeholder)) {
        return this.$t(this.placeholder)
      }

      if (this.placeholderLabel) {
        const placeholderKey = this.domain + '.fields.' + this.name + '.placeholder'
        return this.$te(placeholderKey) ? this.$t(placeholderKey) : ''
      }

      if (this.placeholderConfig) {
        return this.field.options.placeholder
      }

      return ''
    },
    select2Options() {
      // If field is required and has a value, don't allow clearing it
      const formValue = this.getFormValue()
      const hasValue = Array.isArray(formValue)
        ? formValue.length > 0
        : formValue !== null && formValue !== undefined && formValue !== ''
      const isRequired = this.field.options?.required === true
      const canClear = !this.notRemove && !(isRequired && hasValue)
      let optionComplement = {
        allowClear: canClear,
        templateSelection: this.iformat,
        templateResult: this.iformat,
        allowHtml: true,
        language: this.$i18n.locale,
      }

      if (this.domain && !this.field.options.placeholder) {
        const placeholderKey = this.domain + '.fields.' + this.name + '.placeholder'
        optionComplement['placeholder'] = this.placeholderConfig
          ? this.$te(placeholderKey)
            ? this.$t(placeholderKey)
            : this.$t('button.select')
          : this.$t('button.select')
      } else {
        optionComplement['placeholder'] = this.resolvedPlaceholder ?? this.$t('button.select')
      }

      if (this.hasPlaceholderAsOption) {
        delete optionComplement['placeholder'] // Placehold is added as an option
      }

      if (this.field.options === undefined || this.field.options.width === undefined) {
        optionComplement['width'] = '100%'
      }

      let parentModal = this.$refs[this.inputId]?.closest('.modal')?.id
      if (
        parentModal !== undefined &&
        (this.field.options === undefined || this.field.options.dropdownParent === undefined)
      ) {
        // Escape dots in the ID for jQuery selector
        const escapedModalId = parentModal.replace(/\./g, '\\.')
        optionComplement['dropdownParent'] = $(`#${escapedModalId}`)
      }

      if (
        this.field.options.ajax !== undefined &&
        (!this.field.options.ajax || typeof this.field.options.ajax === 'object')
      ) {
        optionComplement['ajax'] = {
          ...this.field.options.ajax,
          delay: 500,
          transport: (params, success) => {
            if (!params.url) {
              params.url = 'entities'
            }

            let searchParams
            let url = null
            try {
              url = new URL(params.url)
              searchParams = url.searchParams
            } catch (error) {
              url = params.url
              searchParams = new URLSearchParams()
            }

            if (params.data.term) {
              searchParams.set('q', params.data.term)
              if (this.field.type === 'article_autocomplete') {
                if (this.platformParamId) {
                  searchParams.set('pp', this.platformParamId)
                } else if (this.platformId) {
                  searchParams.set('p', this.platformId)
                }
              } else if (this.field.type === 'entity_identity' && this.name === 'sirenSupplier') {
                searchParams.set('inFormation', 0)
              }

              if (url instanceof URL) {
                url = url.toString()
              } else {
                url = `${url}?${searchParams.toString()}`
              }

              this.getJSON(url, null).then((datas) => {
                success(datas)
              })
            }
          },
          processResults: (datas) => {
            let items = datas
            if (datas.hasOwnProperty('results')) {
              items = datas.results
            }

            const results = items.map((obj) => {
              obj.text ??= obj.name
              return obj
            })

            this.results = results

            this.$emit('get-autocomplete-result', results)

            if (this.groupProperty !== null) {
              const groups = Object.entries(groupBy(results, this.groupProperty))
              const groupedResults = groups.map(([group, options]) => ({
                text: group,
                children: options,
              }))

              return { results: orderBy(groupedResults, ['text'], ['asc']) }
            }

            return { results }
          },
        }
      }

      if (this.field.options.ajax === true) {
        optionComplement['ajax'] = {
          url: 'v2/entities/autocomplete',
          delay: 500,
          transport: async (params, success) => {
            //pour reprendre la valeur
            if (!params.data.term && this.getFormObjectValue()) {
              params.data.term = this.getFormObjectValue()
            }

            if (params.data.term) {
              let url = `${params.url}?q=${params.data.term}`
              let response = []

              try {
                response = await this.getJSON(url, null)
              } catch {}

              success(response.results ?? [])
            }
          },
          processResults: (datas) => {
            return { results: [{ text: this.$t('entity.pappers.resultats'), children: datas }] }
          },
        }
      }

      if (this.field.options && this.field.options['data-tags']) {
        optionComplement['tags'] = true
        optionComplement['createTag'] = (params) => {
          let term = params.term
          if (term === '') {
            return null
          }

          let dataTags = {
            id: term,
            text: term,
            newTag: true,
          }

          if (this.results.length > 0) {
            this.results.forEach((result) => {
              if (result.id === params.term) {
                dataTags = null
              }
            })
          }

          return dataTags
        }
      }

      if (this.field.options.multiple) {
        optionComplement['theme'] = 'classic'
      }

      optionComplement['language'] = {
        noResults: () => this.$t('autocomplete.noResultsFound'),
        inputTooShort: () => this.$t('autocomplete.minimumInputLength'),
        searching: () => this.$t('autocomplete.searching'),
      }

      return { ...this.field.options, ...optionComplement }
    },
    datepickerElement() {
      if (this.name.includes('.')) {
        const id = this.name.split('.').join('-')
        return $('#' + id + this.formRef)
      } else {
        return $('#' + this.inputId)
      }
    },
    datePickerOptions() {
      let optionComplement = {
        todayHighlight: true,
        language: this.$i18n.locale,
        format: 'dd/mm/yyyy',
      }

      if (this.minDatetime) {
        optionComplement['startDate'] = this.toPickerDate(this.minDatetime)
      }
      if (this.maxDatetime) {
        optionComplement['endDate'] = this.toPickerDate(this.maxDatetime)
      }

      const viewDate = this.minDatetime ?? this.maxDatetime
      if (viewDate && !this.getFormValue()) {
        const date = DateTime.fromISO(viewDate)
        if (date.isValid) {
          optionComplement['defaultViewDate'] = { year: date.year, month: date.month - 1, day: date.day }
        }
      }

      let parentModal = this.$refs[this.inputId]?.closest('.modal')?.id
      if (undefined !== parentModal) {
        optionComplement['container'] = '#' + parentModal
      }

      return Object.assign({}, optionComplement)
    },
    allowedTypes() {
      const supportedExtensions = conf.fileExtensionAuthorized.split(',')

      return supportedExtensions.map((extension) => `.${extension}`).join(',')
    },
    valueFormated() {
      let formValue = this.getFormValue()
      if (formValue === undefined || formValue === null || formValue === '') {
        return ''
      }
      let date = DateTime.fromISO(formValue) //Format à l'initialisation
      if (!date.isValid) {
        date = DateTime.fromFormat(formValue, 'dd/MM/yyyy') //Format au changement
      }
      if (!date.isValid || formValue.length < 3) {
        return formValue
      }

      return (formValue = date.toFormat('dd/MM/yyyy').toString())
    },

    form() {
      const formCreator = this.getFormCreator()
      if (!formCreator) {
        return formCreator
      }
      if (formCreator.def !== undefined) {
        let fieldDefPath = this.name
        if (this.collectionSpecific) {
          fieldDefPath = `${this.collectionName}.${this.collectionIndex}`
        } else if (this.collectionName) {
          fieldDefPath = this.collectionPrototype
            ? `${this.collectionName}.options.prototype.${this.name}`
            : `${this.collectionName}[${this.collectionIndex}].${this.name}`
        }

        this.field = get(formCreator.def, fieldDefPath)
      }

      if (!this.field) {
        return
      }
      if (!this.field.options.display && !(this.field.options.required && this.field.options.display)) {
        return
      }
      if (this.field.options.displayFront === false) {
        return
      }

      // Hide select fields that are optional, disabled, and have no value
      if (this.isSelect && this.field.options.disabled && !this.field.options.required) {
        const fieldValue = this.getFormObjectValue()
        if (!fieldValue) {
          return
        }
      }

      if (user?.isReadOnly && !this.ignoreUserReadonly) {
        this.field.options.disabled = true
      }
      let fieldValue = this.getFormObjectValue()

      if (fieldValue === null && !formCreator.object) {
        fieldValue = formCreator.datas?.[this.name] ?? null
      }

      let form = formCreator.datas
      let errors = formCreator.errors
      let fieldsToRemove = formCreator.datasToRemove
      if (this.collectionName) {
        let collection = form[this.collectionName] || []
        let collectionItem = collection[this.collectionIndex] || {}

        errors[this.collectionName] = errors[this.collectionName] || []
        errors[this.collectionName][this.collectionIndex] = errors[this.collectionName][this.collectionIndex] || {}

        const isCheckbox = this.field.type === 'checkbox'
        const isEmpty = isCheckbox
          ? fieldValue === null || fieldValue === undefined
          : fieldValue === null || fieldValue === undefined || fieldValue === ''
        let hasPatternError = false
        // @TODO refactor backend because right now number fields have fixed patterns of 2 decimals
        if (!isEmpty && this.field.options.constraints?.pattern && this.field.type === 'text') {
          hasPatternError = !testPattern(this.field.options.constraints.pattern, String(fieldValue))
        }

        errors[this.collectionName][this.collectionIndex][this.name] =
          (this.field.options.required && isEmpty) || hasPatternError

        // Only mark disabled field for removal if it has no value
        if (this.field.options.disabled && !fieldValue) {
          fieldsToRemove[this.collectionName] = fieldsToRemove[this.collectionName] || []
          fieldsToRemove[this.collectionName][this.collectionIndex] =
            fieldsToRemove[this.collectionName][this.collectionIndex] || {}
          fieldsToRemove[this.collectionName][this.collectionIndex][this.name] = this.name
        }

        if (this.collectionSpecific) {
          collectionItem = fieldValue
          fieldsToRemove[this.collectionName] = this.collectionIndex
        } else {
          collectionItem[this.name] = fieldValue
        }

        collection[this.collectionIndex] = collectionItem
        form[this.collectionName] = collection
      } else {
        // For multiple/multipleChoice fields, ensure initial value is an array
        if ((this.selectMultiple || this.multipleChoice) && fieldValue && !Array.isArray(fieldValue)) {
          form[this.name] = [fieldValue]
        } else {
          form[this.name] = fieldValue
        }

        if (!this.notRequired) {
          let hasPatternError = false
          if (fieldValue && this.field.options.constraints?.pattern) {
            hasPatternError = !testPattern(this.field.options.constraints.pattern, String(fieldValue))
          }

          const isEmpty = fieldValue === null || fieldValue === undefined || fieldValue === ''
          errors[this.name] = (this.field.options.required && isEmpty) || hasPatternError
        }

        // Only mark disabled field for removal if it has no value (for select2, include it if it has a value)
        if (this.field.options.disabled && !this.notRemove && !fieldValue) {
          fieldsToRemove[this.name] = this.name
        } else if (fieldsToRemove[this.name]) {
          delete fieldsToRemove[this.name]
        }
      }
      return form
    },
    inputId() {
      let escapedName = this.name
      if (this.name.includes('.')) {
        escapedName = this.name.replace(/\./g, '-')
      }
      return escapedName + this.formRef
    },
    isSelect() {
      const type = this.field?.type
      return (
        [
          'choice',
          'entity',
          'buyer',
          'entity_autocomplete',
          'entity_identity',
          'article_autocomplete',
          'enum',
          'country',
          'contract_autocomplete',
        ].includes(type) || this.field?.mainType === 'choice'
      )
    },
    groupedChoices() {
      if (!this.groupProperty) {
        return []
      }

      return groupBy(this.choices, this.groupProperty)
    },
    /**
     * Get the selected value
     * If it is an object, it will return the mapped property.
     *
     * @returns {string|number|null}
     */
    selectedValue() {
      if (isObject(this.modelValue)) {
        return this.modelValue[this.valueProperty]
      }

      return this.modelValue
    },
    /**
     * Get the selected option
     * It will return the selected object.
     *
     * @returns {Object|null}
     */
    selectedOption() {
      if (this.field?.mainType !== FIELD_TYPE_CHOICE) {
        return null
      }

      const options = this.choices.concat(this.results)
      for (let option of options) {
        if (this.form[this.name] === option || this.form[this.name] === option[this.valueProperty ?? 'id']) {
          return option
        }
      }

      return null
    },
    choices() {
      if (this.field?.mainType !== FIELD_TYPE_CHOICE) {
        return null
      }

      if (this.field.type === FIELD_TYPE_ENUM || isObject(this.field?.options?.choices)) {
        return Object.values(this.field.options.choices)
      }

      const choices = [].concat(this.field.options.choices ?? [], this.field.options.ajax?.initValues ?? [])
      if (this.hasPlaceholderAsOption) {
        choices.push({ id: 'null', name: this.resolvedPlaceholder })
      }

      return choices
    },
    hasPlaceholderAsOption() {
      return this.field?.options?.required && this.allowNull
    },
  },

  watch: {
    minDatetime() {
      this.refreshDatepicker()
    },
    maxDatetime() {
      this.refreshDatepicker()
    },
    '$i18n.locale': {
      handler: function () {
        this.$nextTick(() => {
          if (this.field?.type === 'date') {
            this.eventDate() // Forcer le rafraichissement du calendrier pour prendre en compte le changement de locale
          } else if (this.isSelect) {
            this.eventSelect() // Forcer le rafraichissement du select2 pour prendre en compte le changement de locale pour l'option sélectionnée
          }
        })
      },
    },
    disabled(value) {
      if (this.isSelect) {
        this.select.prop('disabled', value)
      }
    },
    field: {
      handler() {
        if (this.field) {
          this.recalculateErrors()
        }
      },
    },
  },

  beforeMount() {
    //on va chercher l'objet config depuis le formulaire créateur avec le nom du champs indiqué
    if (this.name) {
      this.form
    } else {
      return
    }

    //récupération id user entity depuis l'objet def à l'ouverture de la page
    if (this.userEntity && this.getFormCreator()) {
      if (
        this.collectionName &&
        this.getFormCreator().def[this.collectionName][this.collectionIndex][this.name] &&
        this.getFormCreator().def[this.collectionName][this.collectionIndex][this.name].options
      ) {
        const selectedOption = this.getFormCreator().def[this.collectionName][this.collectionIndex][
          this.name
        ].options.choices.find(
          (option) => option.id === this.form[this.collectionName][this.collectionIndex][this.name],
        )
        if (selectedOption) {
          this.userEntityId = selectedOption.id
          if (selectedOption.user) {
            this.userId = selectedOption.user.id
          }
        }
      } else if (this.getFormCreator().def[this.name] && this.getFormCreator().def[this.name].options) {
        if (this.getFormCreator().def[this.name].options.choices != null) {
          const selectedOption = this.getFormCreator().def[this.name].options.choices.find(
            (option) => option.id === this.form[this.name],
          )
        }
        if (typeof selectedOption != 'undefined') {
          if (selectedOption) {
            this.userEntityId = selectedOption.id
          }
          if (selectedOption.user) {
            this.userId = selectedOption.user.id
          }
        }
      }
    }
  },

  mounted() {
    if (this.field?.options?.display) {
      this.quillEditor()

      //event input date
      this.eventDate()

      //event select
      this.eventSelect()

      //event checkbox
      this.eventCheckbox()

      //event file
      this.eventFile()
    }
  },

  updated() {
    this.eventDate()
    this.eventSelect()
    this.quillEditor()
  },

  beforeUnmount: function () {
    if (this.select) {
      this.select.off().select2('destroy')
    }

    $('#' + this.inputId).off('change')
    if (!!this.datepickerElement) {
      this.datepickerElement.datepicker('destroy')
    }

    const formCreator = this.getFormCreator()
    if (formCreator?.errors) {
      formCreator.errors[this.name] = false
    }
  },
}
</script>
<template>
  <div v-if="form" :class="divClasses" :data-test-id="name">
    <div :class="labelDivClasses">
      <label v-if="hasLabel" :for="name" :class="labelClasses">
        <div>
          {{ setLabel }}
        </div>
      </label>
      <i v-if="help && !helpVisible" class="far fa-question-circle mt-1" :title="help"></i>
      <slot v-if="!isDisabled" name="add-before"></slot>
    </div>
    <div
      v-if="editor"
      :id="inputId"
      :ref="inputId"
      :class="editorClasses"
      style="background: white; height: 200px"
    ></div>
    <div v-else :class="simpleInputClasses">
      <input
        v-if="isSimpleInput"
        :id="inputId"
        :type="field.type"
        v-model.lazy="compVal"
        :class="inputFieldClasses"
        :placeholder="resolvedPlaceholder"
        :required="field.options.required"
        :disabled="isDisabled"
        :title="help"
        :min="field.options.constraints?.min"
        :max="field.options.constraints?.max"
        :maxlength="field.options.constraints?.maxlength"
        :step="field.options.constraints?.step"
        :pattern="field.options.constraints?.pattern"
        :e2e-input="name"
        @blur="recalculateErrors()"
        @change="inputChange($event)"
      />
      <slot name="button"></slot>
      <div class="input-group-append" v-if="hasDecoration">
        <span id="basic-addon2"><i :class="field.options.decoration"></i></span>
      </div>

      <input v-if="field.type == 'hidden' || hidden" :id="name" type="hidden" v-model="compVal" :e2e-hidden="name" />

      <textarea
        v-if="field.type == 'textarea'"
        :id="inputId"
        v-model="compVal"
        :class="textareaClasses"
        :placeholder="resolvedPlaceholder"
        :required="field.options.required"
        :disabled="isDisabled"
        @blur="recalculateErrors()"
        :e2e-input="name"
      ></textarea>

      <input
        v-if="field.type == 'date'"
        :id="inputId"
        :ref="inputId"
        type="text"
        v-model="compVal"
        :class="dateInputClasses"
        :placeholder="resolvedPlaceholder"
        :required="field.options.required"
        :disabled="isDisabled"
        autocomplete="off"
        @change="inputChange($event)"
        @blur="recalculateErrors()"
        :e2e-input="name"
      />
      <div v-if="field.type === 'date'" class="input-group-append" @click="onClickCalendar">
        <span id="basic-addon2"><i class="fa fa-calendar"></i></span>
      </div>

      <div v-if="field.type === 'file'" style="position: relative">
        <button ref="fileInput" :class="fileButtonClasses" :e2e-file="name">
          <i class="fas fa-download"></i> {{ $t('document.clickForAdd') }}
        </button>
        <input
          :id="inputId"
          ref="file"
          type="file"
          class="input__file--hidden form-control"
          @change="eventFile($event.target.files)"
          :accept="allowedTypes"
          :e2e-input="name"
        />
      </div>

      <div v-if="isSelect" :class="selectClasses">
        <select
          :id="inputId"
          :class="selectFieldClasses"
          style="min-width: 0; flex-basis: auto; max-width: 100%"
          :ref="inputId"
          :disabled="isDisabled"
          v-model="compVal"
          :multiple="field.options?.multiple ?? false"
          :required="field.options.required"
          @blur="recalculateErrors()"
          :e2e-select="name"
        >
          <template v-if="field.type === 'entity'">
            <option
              v-for="opt in choices"
              :key="opt.id ? opt.id : opt.internalName"
              :data-icon="opt.params?.icon"
              :data-color="opt.params?.style.color"
              :value="getOptionValue(opt)"
              :e2e-option="opt.id ? opt.id : opt.internalName"
            >
              {{ getOptionLabel(opt) }}
            </option>
          </template>
          <template v-else-if="field.type === 'entity_autocomplete'">
            <option
              v-if="field?.options?.choices !== null && field?.options?.choices.length > 0"
              v-for="opt in field.options.choices"
              :key="opt.id ? opt.id : opt.internalName"
              :value="opt.id ? opt.id : opt.internalName"
              :e2e-option="opt.id ? opt.id : opt.internalName"
            >
              {{ opt.name ? opt.name : opt.user ? opt.user.name : opt.id }}
            </option>
            <option v-for="opt in field.options.ajax.initValues" :key="opt.id" :value="opt.id" :e2e-option="opt.id">
              {{ opt.text }}
            </option>
          </template>
          <template v-else-if="field.type === 'article_autocomplete'">
            <option
              v-if="field.options.ajax.initValues"
              v-for="opt in field.options.ajax.initValues"
              :key="opt.id"
              :value="opt.id"
              :disabled="isDisabledOption(opt.id)"
              :e2e-option="opt.id"
            >
              {{ opt.text }}
            </option>
          </template>
          <template v-else-if="(field.type === 'choice' || field.type === 'enum') && !multipleChoice">
            <OptionItem
              v-for="(value, name) in field.options.choices"
              :key="value"
              :label="field.options.translate ? $t(name + '.label') : name"
              :value="value"
              :selected="value === selectedValue"
              :disabled="isDisabledOption(value)"
              :e2e-option="value"
            />
          </template>
          <template v-else-if="field.type === 'country'">
            <option v-for="(value, name) in field.options.choices" :key="name" :value="name" :e2e-option="name">
              {{ value }}
            </option>
          </template>
          <template v-else-if="field.type === 'choice' && multipleChoice">
            <option
              v-for="opt in field.options.choices"
              :key="opt.id ? opt.id : opt"
              :value="opt.id ? opt.id : opt"
              :disabled="isDisabledOption(opt.id ? opt.id : opt)"
              :e2e-option="opt.id ? opt.id : opt"
            >
              {{ opt.name ? opt.name : opt.id ? opt.id : opt }}
            </option>
          </template>
          <template v-else-if="field.type === 'enum' && multipleChoice">
            <option
              v-for="value in field.options.choices"
              :key="value"
              :value="value"
              :disabled="isDisabledOption(value)"
              :e2e-option="value"
            >
              {{ value }}
            </option>
          </template>
          <template v-else-if="field.type === 'entity_identity' && field.options && field.options['choices']">
            <option
              v-for="opt in field.options.choices"
              :value="opt[valueProperty ?? 'siren']"
              :disabled="isDisabledOption(opt[valueProperty ?? 'siren'])"
              :e2e-option="opt[valueProperty ?? 'siren']"
            >
              {{ getEntityOptionLabel(opt) }}
            </option>
          </template>
          <template v-else-if="choices?.length > 0">
            <template v-if="groupProperty">
              <optgroup v-for="(choices, group) in groupedChoices" :key="group" :label="group">
                <OptionItem
                  v-for="opt in choices"
                  :key="opt[valueProperty]"
                  :label="
                    opt.code ? $t('paymentMean.' + opt.code) : (opt[labelProperty] ?? opt.text ?? opt[valueProperty])
                  "
                  :value="opt[valueProperty]"
                  :selected="opt[valueProperty] === selectedValue"
                  :disabled="isDisabledOption(opt[valueProperty])"
                  :e2e-option="opt[valueProperty]"
                />
              </optgroup>
            </template>
            <template v-else>
              <OptionItem
                v-for="opt in choices"
                :key="opt[valueProperty]"
                :label="opt[labelProperty] ?? opt.text ?? opt[valueProperty]"
                :value="opt[valueProperty]"
                :selected="opt[valueProperty] === selectedValue"
                :disabled="isDisabledOption(opt[valueProperty])"
                :e2e-option="opt[valueProperty]"
              />
            </template>
          </template>
          <slot></slot>
        </select>
        <div class="input-group-append" v-if="field.options && field.options.decoration">
          <span id="basic-addon2" :class="addonClasses"><i :class="field?.options?.decoration"></i></span>
          <div :class="'invalid invalid-feedback-' + name + ' is-invalid'"></div>
        </div>
        <slot name="add"></slot>
        <div v-if="showAddUserButtonModal && form" :class="addUserButtonAndModalClasses">
          <AddUserButtonAndModal
            :id="`add-signer${nameAndFormRef}`"
            :user-input-id="inputId"
            :endpoint="endpoint"
            :finance-id="financeId"
            :user-entity-active="userEntity"
            :client-id="Number(clientFindId)"
            :entity-id="entityFindId"
            :simulation-id="simulationFindId"
            :contract-id="contractFindId"
            :user-id="userId"
            :user-entity-id="userEntityId"
            :is-placeholder="addUserPlaceholder"
            @addselect="addSelect(field, $event)"
            @update:user="updateOption($event)"
          />
        </div>
        <div v-if="!user?.isReadOnly && addDirector && !field.options.disabled" class="ml-2">
          <DirectorModal
            :id="directorId"
            :signer-id="'#' + inputId"
            :finance-id="financeId"
            :entity-id="entityFindId"
            ref="director"
            @addselect="addSelect(field, $event)"
          />
        </div>
        <div v-if="!user?.isReadOnly && addEntity && !field.options.disabled" class="ml-2">
          <EntityModal
            ref="entity"
            :id="editEntity ? modelValue : null"
            :context="name"
            small
            @submitted="addEntityOption"
          />
        </div>
      </div>
    </div>
    <div class="order-2 col-md-12">
      <div :id="'invalid-feedback-' + invalidName" class="invalid is-invalid"></div>
    </div>
    <div class="order-3 col-md-12 row" v-if="helpVisible">
      <div class="col-xl-4"></div>
      <div class="col-xl-8 help-bullet"><i class="fa fa-question-circle"></i>&nbsp;{{ help }}</div>
    </div>
  </div>
</template>
